import { HTTP_STATUS } from '../response';
import { Error } from '../error';
import { PortalErrors } from '../change-email-and-password';

/**
 * OAuth is a provider agnostic protocol and so are these actions: the identity
 * provider (`google`, `apple`, …) is nothing but a path segment on the backend
 * endpoints. Adding a provider therefore does not require a new action.
 *
 * Facebook is the one exception, it predates these endpoints and keeps using its
 * own `/api/auth/facebook/*` actions (see `facebook-login`).
 */
export interface OAuthStartResponse {
	status: HTTP_STATUS;
	redirectUrl?: string;
	errors?: Error[];
}

export interface OAuthConfirmResponse {
	status: HTTP_STATUS;
	error?: PortalErrors
}

export interface OAuthLoginToGameResponse {
	status: HTTP_STATUS;
	playerId?: number;
	redirectUrl?: string;
	errors?: Error[];
}

/** Starts the authorization flow and returns the provider's authorization URL. */
export type OAuthStartAction = (provider: string, route: string) => Promise<OAuthStartResponse>;

/** Links the authenticated provider account to the current player. */
export type OAuthConfirmAction = (provider: string) => Promise<OAuthConfirmResponse>;

/** Logs the player identified by the provider account into the game. */
export type OAuthLoginToGameAction = (provider: string) => Promise<OAuthLoginToGameResponse>;
